/*
 * @Author: yuanweijiang
 * @Date: 2023-11-21 14:57:17
 * @LastEditors: yuanweijiang
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import request from './network/request'
import ElementUI from 'element-ui'
import ViewUI from 'view-design'
// import 'view-design/dist/styles/iview.css';
import '@/assets/css/ui/theme/index.css' //导入element-ui自定义主题
import '@/assets/css/iconfont/iconfont.css' //导入字体图标
import '@/assets/css/common.less'
import { VueTransferDom } from 'vue2-transfer-dom'
import ellipsisTooltipDirective from '@/js/utils/v-ellipsis-tooltip'
import TrackingService from '@/store/tracking.js'
// 将埋点服务注册为全局属性
Vue.prototype.$track = TrackingService
// eventBus.js
export const EventBus = new Vue()
Vue.config.devtools = false //隐藏开发环境tools提示
Vue.use(ViewUI)
Vue.use(ElementUI)
Vue.use(VueTransferDom)
import { debounce, throttle } from './js/test.js'
import deleteTip from '@/components/rightSideContainer/components/deleteTip.vue'
Vue.component('deleteTip', deleteTip)
// 在Vue实例上扩展全局方法
Vue.prototype.$debounce = debounce
Vue.prototype.$throttle = throttle
let url = location.href
Vue.prototype.$request = request // 网络请求模块requst
Vue.prototype.$baseUrl = url.substring(0, url.lastIndexOf('/')) //静态资源根路径
Vue.prototype.$EventBus = new Vue()
// console.log(Vue.prototype.$baseUrl)
Vue.config.productionTip = false
Vue.prototype.$testjl = function throttle(func, limit) {
    let inThrottle
    return function () {
        const args = arguments
        const context = this
        if (!inThrottle) {
            func.apply(context, args)
            inThrottle = true
            setTimeout(() => (inThrottle = false), limit)
        }
    }
}
//重定向到登录页指令
Vue.prototype.$triggerSSOLogin = function () {
    const ssoLoginUrl = '/authapi/auth/oauth2/authorize'
    const redirectUri = encodeURIComponent(window.location.origin + '/sso')
    const ssoUrl = `${ssoLoginUrl}?scope=server&redirect_uri=${redirectUri}&response_type=code&client_id=aidesign`
    window.location.href = ssoUrl
}
Vue.prototype.$downloadFile = function downloadFile(path, name) {
    const link = document.createElement('a')
    // 文件路径相对于 public 目录根路径（Vite/Vue/React 通用）
    link.href = path
    link.download = name + '.geojson' // 可选：设置下载后的文件名
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
Vue.directive('drag', (el) => {
    const oDiv = el // 当前元素
    const minTop = oDiv.getAttribute('drag-min-top')
    const ifMoveSizeArea = 20
    oDiv.onmousedown = (e) => {
        let target = oDiv
        while (window.getComputedStyle(target).position !== 'absolute' && target !== document.body) {
            target = target.parentElement
        }

        document.onselectstart = () => {
            return false
        }
        if (!target.getAttribute('init_x')) {
            target.setAttribute('init_x', target.offsetLeft)
            target.setAttribute('init_y', target.offsetTop)
        }

        const initX = parseInt(target.getAttribute('init_x'))
        const initY = parseInt(target.getAttribute('init_y'))

        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - target.offsetLeft
        const disY = e.clientY - target.offsetTop
        document.onmousemove = (e) => {
            // 通过事件委托，计算移动的距离
            // 因为浏览器里并不能直接取到并且使用clientX、clientY,所以使用事件委托在内部做完赋值
            const l = e.clientX - disX
            const t = e.clientY - disY
            const { marginTop: mt, marginLeft: ml } = window.getComputedStyle(target)
            // 计算移动当前元素的位置，并且给该元素样式中的left和top值赋值
            target.style.left = l - parseInt(ml) + 'px'
            target.style.top = (t < minTop ? minTop : t) - parseInt(mt) + 'px'
            if (Math.abs(l - initX) > ifMoveSizeArea || Math.abs(t - initY) > ifMoveSizeArea) {
                target.setAttribute('dragged', '')
            } else {
                target.removeAttribute('dragged')
            }
        }
        document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
            document.onselectstart = null
        }
        // return false不加的话可能导致黏连，拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false
    }
})
// 应用启动前预加载关键图片
function preloadCriticalImages() {
    const criticalImages = [require('./assets/images/login/backing.jpg')]

    criticalImages.forEach((imgSrc) => {
        const img = new Image()
        img.src = imgSrc
    })
}

// 在Vue实例创建前执行预加载
preloadCriticalImages()

Vue.directive('ellipsis-tooltip', ellipsisTooltipDirective)

new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App)
})
